import React from 'react';
import CheckIcon from '@material-ui/icons/Check';

const CIRCLE = 26;

const StageTracker = ({ stages = [], currentStageId }) => {
  const ordered = stages
  const currentIndex = ordered.findIndex((stage) => stage?.id === currentStageId);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
      {ordered.map((stage, index) => {
        const done = currentIndex >= 0 && index < currentIndex;
        const active = index === currentIndex;
        return (
          <div key={stage?.id} style={{ position: 'relative', flex: 1, minWidth: 0, textAlign: 'center', padding: '0 4px' }}>
            {index < ordered.length - 1 ? (
              <div style={{
                position: 'absolute', top: CIRCLE / 2 - 1, height: 2,
                left: `calc(50% + ${CIRCLE / 2}px)`, right: `calc(-50% + ${CIRCLE / 2}px)`,
                backgroundColor: done ? '#059669' : '#e3e6ec',
              }} />
            ) : null}
            <div style={{
              position: 'relative', width: CIRCLE, height: CIRCLE, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto', fontSize: 12, fontWeight: 700, color: done || active ? '#fff' : '#9ca3af',
              backgroundColor: done ? '#059669' : active ? '#4f46e5' : '#eef0f4',
            }}>
              {done ? <CheckIcon style={{ fontSize: 15 }} /> : index + 1}
            </div>
            <div style={{ fontSize: 11, marginTop: 4, color: '#6b7280', overflowWrap: 'break-word' }}>{stage?.name || ''}</div>
          </div>
        );
      })}
    </div>
  );
};

export default StageTracker;
